// extracted by mini-css-extract-plugin
export var cardIcon = "_6y-5";
export var cardIconUnframed = "_6y-9";
export var checkboxCard = "_6y-0";
export var checkboxCardSelected = "_6y-4";
export var disabled = "_6y-2";
export var interactive = "_6y-1";
export var outerBorder = "_6y-3";
export var spacerMedium = "_6y-8";
export var spacerSmall = "_6y-7";
export var spacerXsmall = "_6y-6";